import { gql } from "@apollo/client";

export const PREFERENCE_QUERY = gql`
	query GetBuyerPreferences($params: BuyerQueryParams) {
		buyer(params: $params) {
			getBuyerPreferences {
				id
				preference {
					basic {
						propertyType
						propertyTypeOrder
						buyingPurpose
						anchors {
							label
							gps {
								coordinates
								type
							}
							type
						}
						bedrooms {
							max
							min
							value
						}
						budget {
							max
							min
							value
						}
						projects {
							id
							name
							gps {
								coordinates
								type
							}
						}
					}
					consider {
						amenities
						possessionStatus
						facing
						plotFacing
						propertySubType
						spaces
						builtUpArea {
							max
							min
							value
						}
						plotArea {
							max
							min
							value
						}
						floors {
							max
							min
							value
						}
						order
					}
					wontConsider {
						amenities
						builtUpArea {
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
					}
					by
				}
			}
		}
	}
`;

const PURPOSE_AND_PROPERTY_SELECT = gql`
	query ExampleQuery($params: BuyerQueryParams) {
		buyer(params: $params) {
			getBuyerPreferences {
				id
				preference {
					by
					basic {
						propertyType
						buyingPurpose
					}
				}
			}
		}
	}
`;

const PROPERTYTYPE_MUTATION = gql`
	mutation Preferences($params: PreferenceInputParams) {
		preferences(params: $params) {
			updateProperties {
				id
				preference {
					by
					basic {
						buyingPurpose
						anchors {
							type
							label
							gps {
								type
								coordinates
							}
							radius
						}
						bedrooms {
							max
							min
							value
						}
						budget {
							max
							min
							value
						}
						projects {
							id
							name
						}
						propertyType
						propertyTypeOrder
					}
					consider {
						amenities
						builtUpArea {
							key
							max
							min
							value
						}
						plotArea {
							key
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
						order
					}
					wontConsider {
						amenities
						possessionStatus
						facing
						plotFacing
						propertySubType
						spaces
						order
					}
				}
			}
		}
	}
`;

const GENERATE_SUGGESTIONS = gql`
	mutation Preferences($params: PreferenceInputParams) {
		preferences(params: $params) {
			generateSuggestions
		}
	}
`;

const PREFERENCE_HISTORY_LIST_QUERY = gql`
	query PreferenceHistoryList($params: PrefQueryParams) {
		preferences(params: $params) {
			preferenceHistoryList {
				from {
					basic {
						buyingPurpose
						anchors {
							type
							label
							gps {
								type
								coordinates
							}
							radius
						}
						bedrooms {
							key
							max
							min
							value
						}
						budget {
							key
							max
							min
							value
						}
						city
						projects {
							id
							name
						}
						propertyType
						propertyTypeOrder
					}
					consider {
						amenities
						builtUpArea {
							key
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							key
							max
							min
							value
						}
						plotArea {
							key
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
						order
					}
					wontConsider {
						amenities
						builtUpArea {
							key
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							key
							max
							min
							value
						}
						plotArea {
							key
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
						order
					}
				}
				to {
					basic {
						buyingPurpose
						anchors {
							type
							label
							gps {
								type
								coordinates
							}
							radius
						}
						bedrooms {
							key
							max
							min
							value
						}
						budget {
							key
							max
							min
							value
						}
						city
						projects {
							id
							name
						}
						propertyType
						propertyTypeOrder
					}
					consider {
						amenities
						builtUpArea {
							key
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							key
							max
							min
							value
						}
						plotArea {
							key
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
						order
					}
					wontConsider {
						amenities
						builtUpArea {
							key
							max
							min
							value
						}
						possessionStatus
						facing
						floors {
							key
							max
							min
							value
						}
						plotArea {
							key
							max
							min
							value
						}
						plotFacing
						propertySubType
						spaces
						order
					}
				}
				id
				createdAt
				createdBy
			}
		}
	}
`;

const PREFERENCE_HISTORY_COUNT_QUERY = gql`
	query Preferences($params: PrefQueryParams) {
		preferences(params: $params) {
			preferenceHistoryCount {
				count
			}
		}
	}
`;

const PREFERENCE_HISTORY_ONE_QUERY = gql`
	query Preferences($params: PrefQueryParams) {
		preferences(params: $params) {
			preferenceHistoryOne {
				prefId
				by
				basic {
					buyingPurpose
					anchors {
						type
						label
						gps {
							type
							coordinates
						}
						radius
					}
					bedrooms {
						key
						max
						min
						value
					}
					budget {
						key
						max
						min
						value
					}
					city
					projects {
						id
						name
					}
					propertyType
					propertyTypeOrder
				}
				consider {
					amenities
					builtUpArea {
						key
						max
						min
						value
					}
					possessionStatus
					facing
					floors {
						key
						max
						min
						value
					}
					plotFacing
					propertySubType
					spaces
					order
				}
				wontConsider {
					amenities
					possessionStatus
					facing
					plotFacing
					propertySubType
					spaces
					order
				}
				groupId
			}
		}
	}
`;

export const REJECT_PREFERENCE_SUGGESTION_MUTATION = gql`
	mutation Preferences($params: PreferenceInputParams) {
		preferences(params: $params) {
			rejectPrefSuggestions
		}
	}
`;

export const UNDO_REJECTION_MUTATION = gql`
	mutation Preferences($params: PreferenceInputParams) {
		preferences(params: $params) {
			undoRejection
		}
	}
`;
